<template>
  <div>
    <BaseFetchData :action="loadInitialContact">
      <template #default="fetchDataProps">
        <div v-if="fetchDataProps.status.resolved" class="p-8 flex-1">
          <DuplicatesManager
            v-if="subject"
            :key="subject.id"
            :contact="subject"
            @change-contact="changeSubject"
            :on-merge="handleMerge"
          />
          <ContactList v-else :account-id="accountId" @select="changeSubject" />
        </div>
      </template>
    </BaseFetchData>
  </div>
</template>

<script>
import { contactsClient, contactMergeClient } from '@/api/clients';
import components from './contactMerge/components';

export default {
  components,
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      subject: null,
    };
  },
  methods: {
    async loadInitialContact() {
      try {
        if (this.$route.query.contact_id) {
          const response = await contactsClient.read(this.$route.query.contact_id, {
            include: [
              'emailAddresses',
              'phoneNumbers',
              'contactsWithCommonEmailAddressCount',
              'contactsWithCommonPhoneNumberCount',
            ].join(','),
          });

          this.subject = response.data;
        }
      } catch (error) {
        //
      }
    },
    changeSubject(contact) {
      this.subject = contact;
    },
    handleMerge(data) {
      return contactMergeClient.store(this.subject.id, data).then((response) => {
        this.changeSubject(null);
        return Promise.resolve(response);
      });
    },
  },
};
</script>
